import { Star } from 'lucide-react';
import {
  SURVEY_RATING_DEFAULT_MAX,
  SURVEY_RATING_DEFAULT_MIN,
  SURVEY_RATING_SCALE,
} from '../../constants/survey.constants';

export function SurveyRatingPreview() {
  return (
    <div className="space-y-2">
      <div className="flex flex-wrap items-center gap-1">
        {SURVEY_RATING_SCALE.map((position) => (
          <Star key={position} fill="none" className="size-6 text-muted-foreground" aria-hidden />
        ))}
      </div>
      <p className="text-xs text-muted-foreground">
        Rate from {SURVEY_RATING_DEFAULT_MIN} to {SURVEY_RATING_DEFAULT_MAX} (preview)
      </p>
    </div>
  );
}
